import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';
import { lifecycleStatusDefinitionsClient } from '~/services';
import type { LifecycleStatusDefinitionType } from '~/services/lifecycleStatusDefinitions/lifecycleStatusDefinitionsClient.types';
import { useToasted } from '~/composables/useToasted';
import { catchRequestError } from '~/utils/request';

export const useLifecycleStatusDefinitions = createGlobalState(() => {
    const toasted = useToasted();
    const teamId = Spark.state.currentTeam.id;
    const definitions = ref<LifecycleStatusDefinitionType[] | undefined>(undefined);
    const loading = ref(false);

    const fetchDefinitions = async (): Promise<void> => {
        if (loading.value || definitions.value !== undefined) {
            return;
        }
        loading.value = true;
        try {
            const response = await lifecycleStatusDefinitionsClient.getLifecycleStatusDefinitions({ teamId });
            definitions.value = response.data.definitions;
        } catch (err) {
            toasted.error(catchRequestError(err));
            definitions.value = [];
        } finally {
            loading.value = false;
        }
    };

    return { definitions, loading, fetchDefinitions };
});
